<script setup lang="ts">
import useImageHelper from '@/composables/useImageHelper'
import HtmlFormatter from '@/components/HtmlFormatter.vue'
import { IImage } from '@/interface/IImage'
import { defineProps, ref } from 'vue'

const props = defineProps({
  title: String,
  index: {
    type: Number,
    required: true,
  },
  copy: {
    type: String || null,
    required: false,
  },
  long: {
    type: String || null,
    required: false,
  },
  img: {
    type: [Object, String, null, undefined] as PropType<
      IImage | string | null | undefined
    >,
    required: false,
  },
})
const { getImageSrc } = useImageHelper()
const getAspectRatio = (img: IImage | string | null | undefined) => {
  if (!img || typeof img === 'string') return 'auto'
  return img.aspect
}
const input = computed(() => {
  const countable = props.index % 2 === 0
  const image = props.img
    ? `<img src='${getImageSrc(
        props.img
      )}' alt='ph' style='aspect-ratio: ${getAspectRatio(props.img)};'` +
      `class='w-full lg:w-1/2 rounded-[8px] mb-6 ${
        countable ? 'lg:mr-6' : 'lg:ml-6'
      }' ` +
      `align='${countable ? 'left' : 'right'}'>`
    : ''
  const title = `<h2>${props.title}</h2>`
  const copy = props.copy ?? ''
  return image + title + copy
})
</script>

<template>
  <div class="flex flex-col">
    <hr class="mb-6 mt-4 lg:mt-6 lg:mb-10" v-if="index !== 0" />
    <HtmlFormatter
      v-if="copy"
      :html-input="input"
      :style="{ display: 'block' }"
    />
  </div>
</template>

<style scoped lang="scss">
:deep(h2) {
  color: var(--vt-c-text-dark);
  font-weight: bold;
  font-size: 22px;
  line-height: 30px;
  margin: 8px 0;

  @media screen and (min-width: 1024px) {
    font-size: 36px;
    line-height: 50px;
    margin-bottom: 12px;
  }
}
</style>
